import { render, staticRenderFns } from "./ocJump.vue?vue&type=template&id=50626076&scoped=true&"
import script from "./ocJump.vue?vue&type=script&lang=js&"
export * from "./ocJump.vue?vue&type=script&lang=js&"
import style0 from "./ocJump.vue?vue&type=style&index=0&id=50626076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50626076",
  null
  
)

export default component.exports